import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const KPCOFIL_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/kpcofil/logo.png",
        alt: "KP Counseling Logo",
        style: { width: "230px", height: "100%", isMobile: { width: "170px" } },
      },
    },
    icons: {},
  },
  providerGroupId: [121, 4],
  state: "IL",
  departmentIds: [481, 482, 483, 484, 485, 486, 490],
};
